module.exports = __webpack_public_path__ + "static/media/thecountrystore-logo.6920f0ee.png";